<!--钉钉微应用君子签登录页-->
<template>
  <div class="login" :style="{ minHeight: height }"></div>
</template>

<script>
import { dingtalkApi } from "../../assets/js/http-serve/dingtalkApi";
import GlobalConfig from "@/assets/js/config/global";
import { authentication } from "@/assets/js/utils/ding-env";
import { ApiMethods } from "../../assets/js/http-serve/http-methods";
export default {
  name: "index",
  layout: "user",
  data () {
    return {
      dingSDK: null,
      height: "877px",
    };
  },
  async mounted () {
    this.$DingSDKPromise().then((ding) => {
      this.dingSDK = ding;
      if(ding.ready){ this.dingLogin() }
    }).catch(err => {
      console.error('钉钉环境准备失败:', err);
    });
  },
  methods: {
    /** 钉钉登录跳转 */
    dingLogin(){
      const _this = this,{ query } = this.$route, session = sessionStorage;
      let loading = _this.$loading({
        lock: true,
        text: "正在登录",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
      const dingEnv = this.dingSDK.env;
      if (dingEnv.platform != "notInDingTalk") {
        let corpId = query.corpId;
        //在钉钉环境内部
        // 1.接入钉钉性能体验日志 初始化 __BIRD_CONFIG 对象
        window.__BIRD_CONFIG = window.__BIRD_CONFIG || {};
        __BIRD_CONFIG.tags = {
          isvAppId: '130317', // isv应用id
        };
        _this.$jzqCookie.set("jtoken", this.$route.query.t);
        if (corpId) session.setItem("corpId", query.corpId);
        if (!corpId) corpId = session.getItem("corpId")
        if (dingEnv.platform === 'pc') {
          this.dingSDK.runtime.permission.requestAuthCode({
            corpId,
            onSuccess: function (info) {
              session.removeItem("dingloginInfo")
              //通过获取的免登授权码后请求后台接口获取token登录应用，并将token存入缓存
              // console.log("获取到免登授权码", info);
              dingtalkApi
                .login({
                  corpId,
                  requestAuthCode: info.code
                })
                .then(res => {
                  if (!res.success) return _this.$message.error(res.description);
                  const data = res.data
                  session.setItem("dingloginInfo", JSON.stringify(res.data));
                  // 已完成实名
                  if (data.corpAuthed === 1 && data.personAuthed === 1) {
                    // 跳转中间页进行账户中心登录，然后进入首页
                    _this.dingAuth(data)
                  } else {
                    _this.$router.push({ path: '/login/dingMiddle', query: { ..._this.$route.query } })
                  }
                }).finally(() => { loading.close(); });
            },
            onFail: function (err) {
              loading.close();
              console.log("钉钉获取免登授权码错误，请稍后重试！");
            }
          });
        } else {
          // 跳转到H5
          location.href = `${GlobalConfig.domain.junziqianH5Op}/login/middle?corpId=${corpId}`
        }
      }
    },
    dingAuth (data) {
      const _this = this;
      authentication().then(res => {
        if (!res.success) this.$message.error("网络错误，请重试");
        const config = {
          ...res.data,
          jsApiList: [
            'biz.user.get',
            "complexChoose", 
            "chooseStaffForPC", 
            'biz.util.openSlidePanel', 
            'biz.util.invokeWorkbench',
          ]
        };
        this.dingSDK.config(config);
        this.dingSDK.ready(()=>{
          _this.$router.push({
            path: "/dingtalkUse/middlePage",
            query: { ap: "/viewIndex", t: data.jzqCorpToken }
          });
        })
        this.dingSDK.error(function (err) {
          ApiMethods.CommonController.browserLog({
            log: `dd.config_pc error: ${JSON.stringify(err)}`
          })
            .then(data => { })
            .catch(err => { });
        });
      }).catch(err => {
        ApiMethods.CommonController.browserLog({
            log: `PC端钉钉授权鉴权_捕获异常捕获err:::${err}`
          })
            .then(data => { })
            .catch(err => { });
      });
    },
  },
  head () {
    return {
      title: "我的首页",
      // 钉钉监控代码
      meta: process.env.NODE_ENV === 'production' ? [{ name: "wpk-bid", content: "dta_2_130317" }] : [{ name: "wpk-bid", content: "dta_2_135417" }],
      script: [{ src: '/dingMonitor.js' }]
    };
  }
};
</script>


// WEBPACK FOOTER //
// pages/login/middle.vue